import React from 'react';
import styles from '../../assets/styles/Booking/BookingLink.module.scss';
import Logo from '../../assets/img/mima-logo.png';
import {
	MimaButton,
	MimaText,
	PageLoader,
	MimaInput,
	ReceiptCheckBox as RCB,
	MimaDateInput,
	MimaDropdown,
	MimaTextArea,
} from '../../components';
import { paymentLinkStore } from '../../stores';
import { amountFormatter } from '../../utils/utils';
import { Formik } from 'formik';
import countries from '../../utils/countries.json';
import { isSameMinute } from 'date-fns';

const BookingLinkDetails = ({
	bookingLinkDetails,
	validationSchema,
	onSubmit,
	loading,
	getExactCharge,
	charges,
	showCharge,
	setshowCharge,
	paystackCharge,
	unavailableDates,
}) => {
	const business = bookingLinkDetails.business;

	const startSessions = unavailableDates?.sessions?.map(
		session => new Date(session.startSession)
	);

	const filterSelectedTime = time => {
		const currentDate = new Date();
		const selectedDate = new Date(time);

		if (selectedDate > currentDate) {
			const matchingTime = startSessions.find(startSession =>
				isSameMinute(selectedDate, new Date(startSession))
			);

			return !matchingTime;
		}
		return false;
	};

	return (
		<div className={styles.main}>
			{loading ? (
				<PageLoader title="while we load link info" variant="light" />
			) : (
				<>
					<img
						src={business.logoUrl}
						alt="Business Logo"
						className={styles.main__img}
					/>
					<div className={styles.main__titles}>
						<MimaText
							variant="subtitleBold"
							mt={1}
							align="center"
							color="var(--color-white)">
							{bookingLinkDetails.title}
						</MimaText>
						<MimaText
							variant="bodyBold"
							align="center"
							color="var(--color-white)">
							by {business.tradingName}
						</MimaText>
						<MimaText variant="body" align="center" color="var(--color-white)">
							{bookingLinkDetails.description}
						</MimaText>
						<MimaText
							variant="body"
							align="center"
							mb={2}
							color="var(--color-white)">
							{bookingLinkDetails.durationInMinutes} Minutes
						</MimaText>
					</div>

					<Formik
						initialValues={{
							amount:
								!bookingLinkDetails.acceptPartPayment &&
								bookingLinkDetails.amount > 0
									? bookingLinkDetails.amount
									: '',
							fullname: '',
							email: '',
							mobile: '',
							// quantity: 1,
							sessionDateTime: '',
							note: '',
							bookingLink: bookingLinkDetails._id,
							country: '',
							state: '',
							payWith: 'TRANSFER',
							acceptPhoneNumber: bookingLinkDetails.acceptPhoneNumber,
							acceptPartPayment: bookingLinkDetails.acceptPartPayment,
							minDeposit: bookingLinkDetails.minDeposit,
						}}
						validationSchema={validationSchema}
						onSubmit={onSubmit}>
						{({
							handleChange,
							handleBlur,
							handleSubmit,
							setFieldValue,
							values,
							errors,
							touched,
						}) => {
							return (
								<div className={styles.main__form}>
									<MimaText variant="subtitleBold" align="center">
										{bookingLinkDetails.currencyCode}
									</MimaText>

									<MimaDateInput
										labelTitle="Select Booking Date and Time"
										name="sessionDateTime"
										value={values.sessionDateTime}
										onChange={text => {
											setFieldValue('sessionDateTime', text);
										}}
										onBlur={handleBlur}
										touched={touched.sessionDateTime}
										error={errors.sessionDateTime}
										variant="form2"
										excludeWeekends={!unavailableDates.availableWeekends}
										excludePastDays
										// excludeDates={startSessions}
										showTimeSelect
										timeIntervals={bookingLinkDetails.durationInMinutes}
										filterTime={filterSelectedTime}
									/>

									{!bookingLinkDetails.acceptPartPayment &&
									bookingLinkDetails.amount > 0 ? (
										<MimaText
											variant="h3"
											mb={1}
											mt={2}
											labelTitle={'Booking Price'}>
											{amountFormatter(bookingLinkDetails.currencyCode).format(
												bookingLinkDetails.amount
											)}
										</MimaText>
									) : (
										<MimaInput
											labelTitle="Enter payment Amount"
											variant="form2"
											type="number"
											placeholder="0.00"
											name="amount"
											id="amount"
											value={values.amount}
											onChange={handleChange}
											onBlur={e => {
												handleBlur(e);
												setshowCharge(false);
												paymentLinkStore.setCharges();
												if (!bookingLinkDetails.acceptQuantity) {
													getExactCharge(values);
												}
											}}
											touched={touched.amount}
											error={errors.amount}
										/>
									)}

									{/* {
                      bookingLinkDetails.acceptQuantity ? (
                        <MimaInput
                          labelTitle="Quantity"
                          variant="form2"
                          type="number"
                          placeholder="1"
                          name="quantity"
                          id="quantity"
                          value={values.quantity}
                          onChange={handleChange}
                          onBlur={(e) => {
                            handleBlur(e);
                            setshowCharge(false);
                            paymentLinkStore.setCharges();
                            getExactCharge(values);
                          }}
                          touched={touched.quantity}
                          error={errors.quantity}
                        />
                      ) : ""
                    } */}

									<div className={styles.beside}>
										{bookingLinkDetails.amount !== 0 ? (
											<MimaText
												variant="bodyBold"
												color="var(--color-primary)"
												mb={1}
												labelTitle="Amount Due">
												{amountFormatter(
													bookingLinkDetails.currencyCode
												).format(bookingLinkDetails.amount)}
											</MimaText>
										) : (
											' '
										)}

										{bookingLinkDetails.minDeposit !== 0 ? (
											<MimaText
												variant="bodyBold"
												color="var(--color-error)"
												mb={1}
												labelTitle="Minimum Deposit">
												{amountFormatter(
													bookingLinkDetails.currencyCode
												).format(bookingLinkDetails.minDeposit)}
											</MimaText>
										) : (
											' '
										)}
									</div>

									<MimaInput
										labelTitle="Full Name"
										variant="form2"
										placeholder="Full Name"
										name="fullname"
										id="fullname"
										value={values.fullname}
										onChange={handleChange}
										onBlur={e => {
											handleBlur(e);
											setshowCharge(false);
											paymentLinkStore.setCharges();
											getExactCharge(values);
										}}
										touched={touched.fullname}
										error={errors.fullname}
									/>

									<MimaInput
										labelTitle="Your Email Address"
										type="email"
										variant="form2"
										placeholder="Your email address"
										name="email"
										id="email"
										value={values.email}
										onChange={handleChange}
										onBlur={handleBlur}
										touched={touched.email}
										error={errors.email}
									/>

									{bookingLinkDetails.acceptPhoneNumber ? (
										<MimaInput
											labelTitle="Your Phone Number"
											type="tel"
											variant="form2"
											placeholder="Your Phone Number"
											name="mobile"
											id="mobile"
											value={values.mobile}
											onChange={handleChange}
											onBlur={handleBlur}
											touched={touched.mobile}
											error={errors.mobile}
										/>
									) : (
										''
									)}

									<div className={styles.beside}>
										<MimaDropdown
											labelTitle="Country"
											name="country"
											value={values.country}
											placeholder="Select Country"
											id="country"
											currentValue={values.country}
											onChange={data => {
												setFieldValue('country', data.key);
											}}
											data={countries.map(value => {
												return {
													key: value.country,
													value: value.country,
												};
											})}
											touched={touched.country}
											error={errors.country}
											variant="filterForm"
											bodyVariant="bodyBase2"
											// mb={-1}
										/>

										<MimaDropdown
											labelTitle="State"
											name="state"
											value={values.state}
											placeholder="Select State"
											id="state"
											currentValue={values.state}
											onChange={data => {
												setFieldValue('state', data.key);
											}}
											data={
												countries
													.find(value => value.country === values.country)
													?.states.map(state => {
														return {
															key: state,
															value: state,
														};
													}) || []
											}
											touched={touched.state}
											error={errors.state}
											variant="filterForm"
											bodyVariant="bodyBase2"
											// mb={-1}
										/>
									</div>

									<MimaTextArea
										labelTitle="Notes"
										textAreaVariant="type3"
										placeholder="Add Notes"
										name="note"
										id="note"
										value={values.note}
										onChange={handleChange}
										onBlur={handleBlur}
										touched={touched.note}
										error={errors.note}
										mt={-2}
									/>

									<div className={styles.beside}>
										{bookingLinkDetails.currencyCode === 'NGN' && (
											<RCB
												title="Pay with Transfer"
												onChange={() => {
													setFieldValue('payWith', 'TRANSFER');
												}}
												checked={values.payWith === 'TRANSFER'}
												value="TRANSFER"
												name="payWith"
											/>
										)}
										{bookingLinkDetails.currencyCode === 'NGN' && (
											<RCB
												title="Pay with Card"
												onChange={() => {
													setFieldValue('payWith', 'CARD');
												}}
												checked={values.payWith === 'CARD'}
												value="CARD"
												name="payWith"
											/>
										)}

										{showCharge && values.payWith === 'TRANSFER' ? (
											<>
												<MimaText
													variant="bodyBold"
													color="var(--color-primary-4)"
													mb={1}
													labelTitle="Payment Charge">
													{amountFormatter(
														bookingLinkDetails.currencyCode
													).format(charges?.chargeAmount)}
												</MimaText>

												<MimaText
													variant="bodyBold"
													color="var(--color-green)"
													mb={1}
													labelTitle="You will pay">
													{amountFormatter(
														bookingLinkDetails.currencyCode
													).format(values.amount + charges?.chargeAmount)}
												</MimaText>
											</>
										) : (
											''
										)}

										{values.payWith === 'CARD' ? (
											<>
												<MimaText
													variant="bodyBold"
													color="var(--color-primary-4)"
													mb={1}
													labelTitle="Payment Charge">
													{amountFormatter(
														bookingLinkDetails.currencyCode
													).format(paystackCharge)}
												</MimaText>

												<MimaText
													variant="bodyBold"
													color="var(--color-green)"
													mb={1}
													labelTitle="You will pay">
													{amountFormatter(
														bookingLinkDetails.currencyCode
													).format(values.amount + paystackCharge)}
												</MimaText>
											</>
										) : (
											''
										)}
									</div>

									<MimaButton
										title="Make Payment"
										onClick={handleSubmit}
										variant="filterForm"
										mt={2}
									/>

									<div className={styles.mima}>
										<p>Powered by</p>{' '}
										<img
											src={Logo}
											alt="Mima Logo"
											className={styles.mima__logo}
										/>
									</div>
								</div>
							);
						}}
					</Formik>
				</>
			)}
		</div>
	);
};

export default BookingLinkDetails;
